import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useMe } from '../context/MeContext';
import PendingApproval from './PendingApproval';

const Spinner = () => (
  <Box sx={{ p: 6, textAlign: 'center' }}>
    <CircularProgress />
  </Box>
);

/**
 * Two gates, in order: are you signed in, and has a clinic admin approved you?
 * The backend enforces both independently (MembershipEnforcementMiddleware) —
 * this only decides what the user sees instead of a wall of failed requests.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { loaded, isActiveMember } = useMe();

  if (loading) return <Spinner />;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Wait for /api/Me before deciding — otherwise an approved user sees the
  // waiting screen flash on every page load.
  if (!loaded) return <Spinner />;

  if (!isActiveMember) return <PendingApproval />;

  return children;
};

export default ProtectedRoute;
